/* DARKGROUND DESIGN SYSTEM · bundles + collection players
   [data-dg-bsounds]: for each [data-dg-bsound] row, loads the product's AW Player tracks, picks the "Demo" track
   (or the longest) and plays it. One sound at a time, click the bar to seek.
   Rows with [data-dg-lazy] load only when their card scrolls into view (collection pages).
   A hidden section is shown as soon as one row has a sound.
*/
(function () {
  'use strict';
  var audio = null;
  var current = null;

  function secs(d) {
    if (typeof d === 'number') return d;
    if (!d) return 0;
    var s = String(d);
    if (s.indexOf(':') > -1) {
      return s.split(':').map(Number).reduce(function (acc, n) { return acc * 60 + (n || 0); }, 0);
    }
    return parseFloat(s) || 0;
  }
  function fmt(s) {
    s = Math.max(0, Math.round(s || 0));
    var m = Math.floor(s / 60);
    var r = s % 60;
    return m + ':' + (r < 10 ? '0' : '') + r;
  }
  function stopCurrent() {
    if (!current) return;
    current.classList.remove('is-playing');
    var bar = current.querySelector('[data-bar]');
    if (bar) bar.style.width = '0%';
  }
  function getAudio() {
    if (audio) return audio;
    audio = new Audio();
    audio.preload = 'none';
    audio.addEventListener('timeupdate', function () {
      if (!current || !audio.duration) return;
      var bar = current.querySelector('[data-bar]');
      if (bar) bar.style.width = (audio.currentTime / audio.duration * 100) + '%';
      var tm = current.querySelector('[data-time]');
      if (tm) tm.textContent = fmt(audio.currentTime) + ' / ' + fmt(audio.duration);
    });
    audio.addEventListener('ended', function () { stopCurrent(); current = null; });
    return audio;
  }

  var cache = {};
  function getTracks(pid) {
    if (!cache[pid]) {
      cache[pid] = fetch('/apps/awplayer/tracks?product_id=' + pid, { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (d) { return ((d && d.tracks) || []).filter(function (t) { return t && t.url; }); })
        .catch(function () { return []; });
    }
    return cache[pid];
  }

  function load(row, section) {
    var pid = row.getAttribute('data-product-id');
    if (!pid) return;
    getTracks(pid).then(function (tracks) {
      if (!tracks.length) return;
      var idx = -1;
      for (var i = 0; i < tracks.length; i++) { if (/demo/i.test(tracks[i].title || '')) { idx = i; break; } }
      var label = row.getAttribute('data-demo-label') || 'Demo';
      if (idx < 0) {
        idx = 0;
        tracks.forEach(function (t, j) { if (secs(t.duration) > secs(tracks[idx].duration)) idx = j; });
        label = row.getAttribute('data-featured-label') || 'Featured sound';
      }
      var t = tracks[idx];
      row.setAttribute('data-src', t.url);
      var lb = row.querySelector('[data-label]');
      if (lb) lb.textContent = label;
      var tm = row.querySelector('[data-time]');
      if (tm && t.duration) tm.textContent = fmt(secs(t.duration));
      row.hidden = false;
      if (section && section.hidden) section.hidden = false;
    });
  }

  var lazyIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      lazyIO.unobserve(e.target);
      var row = e.target.__dgRow;
      if (row) load(row, row.__dgSection);
    });
  }, { rootMargin: '300px 0px' }) : null;

  function bind(root) {
    (root || document).querySelectorAll('[data-dg-bsounds]').forEach(function (section) {
      if (section.dataset.dgBound) return;
      section.dataset.dgBound = '1';
      section.querySelectorAll('[data-dg-bsound]').forEach(function (row) {
        if (row.hasAttribute('data-dg-lazy') && lazyIO && row.parentElement) {
          row.parentElement.__dgRow = row;
          row.__dgSection = section;
          lazyIO.observe(row.parentElement);
        } else {
          load(row, section);
        }
        var btn = row.querySelector('.dg-bs__play');
        if (btn) btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var src = row.getAttribute('data-src');
          if (!src) return;
          var a = getAudio();
          if (current === row && !a.paused) { a.pause(); row.classList.remove('is-playing'); return; }
          if (current !== row) { stopCurrent(); current = row; a.src = src; }
          var p = a.play();
          if (p && p.then) p.then(function () { row.classList.add('is-playing'); }).catch(function () {});
          else row.classList.add('is-playing');
        });
        var seek = row.querySelector('[data-seek]');
        if (seek) seek.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (current !== row || !audio || !audio.duration) return;
          var r = seek.getBoundingClientRect();
          audio.currentTime = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width)) * audio.duration;
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { bind(document); });
  else bind(document);
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
